<template>
          <!-- contents -->
          <div id="contents">
            <div class="contents_wrap">
              <!-- contents_head -->
              <!-- breadcrumbs -->
              <skp-breadcrumbs @page-title="val => pageTitle = val" />
              <!-- //breadcrumbs -->
              <h2 class="pg_title">{{ pageTitle }}</h2>
              <!-- //contents_head -->

              <!-- srchTop_wrap -->
              <div class="srchTop_wrap">
                <article class="srch_basic">
                  <div class="srch_grup">
                    <ul class="w50">
                      <li class="tit_150">Subsidiary</li>
                      <li data-input-type="select" class="w100-150">
                        <fieldset class="ui_fieldset set_3">
                          <div>
                            <select id="selectRhqCd1" name="selectRhqCd1" v-model="selectRhqCd" @change="changeRhqCd($event)" class="slt_white w100">
                                <option value="" v-if="isAllUser() ? true : false" >{{ $t('FIELD.GLOBAL.ALL') }}</option>
                                <option v-for="(item, index) in rhqCdList"
                                        :key="item.code"
                                        :value="item.code"
                                        :selected="selectRhqCd ? (item.code == selectRhqCd ? true : false) : (index === 0 ? true : false)">{{item.codeName}}</option>
                            </select>
                          </div>
                          <div>
                            <select id="selectRhqSubCd1" name="selectRhqSubCd1" v-model="selectRhqSubCd" @change="changeRhqSubCd($event)" class="slt_white w100">
                                <option value="" v-if="isAllUser() ? true : false" >{{ $t('FIELD.GLOBAL.ALL') }}</option>
                                <option v-for="(item, index) in rhqSubCdList"
                                        :key="item.code"
                                        :value="item.code"
                                        :selected="selectRhqSubCd ? (item.code == selectRhqSubCd ? true : false) : (index === 0 ? true : false)">{{item.codeName}}</option>
                            </select>
                          </div>
                        </fieldset>
                      </li>
                    </ul>

                    <ul class="w50">
                        <li class="tit_150">Content</li>
                        <li data-input-type="select" class="w100-150">
                            <fieldset class="ui_fieldset set_2">
                                <div>
                                    <select 
                                        id="BOARD_TYPE1"
                                        name="BOARD_TYPE1"
                                        v-model="BOARD_TYPE1"
                                        class="slt_white w100p"
                                        @change="changeBoardType1($event)"
                                    >
                                        <option value="" selected>{{ $t('FIELD.GLOBAL.ALL') }}</option>
                                        <option v-show="boardType1List.length > 0"
                                                v-for="item in boardType1List"
                                                :key="item.code"
                                                :value="item.code"
                                        >{{item.codeName}}</option>
                                    </select>
                                </div>
                                <div>
                                    <select
                                        id="BOARD_TYPE2"
                                        name="BOARD_TYPE2"
                                        v-model="BOARD_TYPE2"
                                        class="slt_white w100p"
                                    >
                                        <option value="" selected>{{ $t('FIELD.GLOBAL.ALL') }}</option>
                                        <option v-show="boardType2List.length > 0"
                                                v-for="item in boardType2List"
                                                :key="item.code"
                                                :value="item.code"
                                                :data-menu-grp-dtl-cd="item.menuGrpDtlCd"
                                        >{{item.codeName}}</option>
                                    </select>
                                </div>
                            </fieldset>
                        </li>
                    </ul>
                    <ul class="w100">
                      <li class="tit_150">Category</li>
                      <li data-input-type="select" class="w100-150">
                        <fieldset class="ui_fieldset set_3">
                          <div>
                            <select class="slt_white w100p"
                                    id="PRD_CATEGORY_CD1"
                                    v-model="PRD_CATEGORY_CD1"
                                    @change="changeCategory1($event)">
                                <option value="" selected>{{ $t('FIELD.GLOBAL.ALL') }}</option>
                                <option v-show="categoryComboList1.length > 0"
                                        v-for="item in categoryComboList1"
                                        :key="item.code"
                                        :value="item.code"
                                >{{item.codeName}}</option>
                            </select>
                          </div>
                          <div>
                            <select class="slt_white w100p"
                                    id="PRD_CATEGORY_CD2"
                                    v-model="PRD_CATEGORY_CD2"
                                    @change="changeCategory2($event)">
                                <option value="" selected>{{ $t('FIELD.GLOBAL.ALL') }}</option>
                                <option v-show="categoryComboList2.length > 0"
                                        v-for="item in categoryComboList2"
                                        :key="item.code"
                                        :value="item.code"
                                >{{item.codeName}}</option>
                            </select>
                          </div>
                          <div>
                            <select class="slt_white w100p"
                                    id="PRD_CATEGORY_CD3"
                                    v-model="PRD_CATEGORY_CD3"
                                    @change="changeCategory3($event)">
                                <option value="" selected>{{ $t('FIELD.GLOBAL.ALL') }}</option>
                                <option v-show="categoryComboList3.length > 0"
                                        v-for="item in categoryComboList3"
                                        :key="item.code"
                                        :value="item.code"
                                >{{item.codeName}}</option>
                            </select>
                          </div>
                        </fieldset>
                      </li>
                    </ul>
                    <ul class="w50">
                        <li class="tit_150">
                            Period <em class="txt_mandatory">*</em>
                        </li>
                        <dd data-input-type="date">
                            <fieldset class="ui_fieldset">
                                <span class="date-wrap">
                                    <label>
                                        <input id="fromDate" type="text" class="date_input w100p bg_white" readonly :placeholder="$t('FIELD.KNOWLEDGE.SEARCH.FROMDATE')">
                                        <a href="javascript:" class="in_btn" id="icoFromDate"><i class="ico_date"></i><span class="sr_only">{{ $t('FIELD.GLOBAL.DATE') }}</span></a>
                                    </label>
                                    <div id="from-picker-container" style="margin-top: -1px;"></div>
                                </span>
                                <em class="txt_space"></em>
                                <span class="date-wrap">
                                    <label>
                                        <input id="toDate" type="text" class="date_input w100p bg_white" readonly :placeholder="$t('FIELD.KNOWLEDGE.SEARCH.TODATE')">
                                        <a href="javascript:" class="in_btn" id="icoToDate"><i class="ico_date"></i><span class="sr_only">{{ $t('FIELD.GLOBAL.DATE') }}</span></a>
                                    </label>
                                    <div id="to-picker-container" style="margin-top: -1px;"></div>
                                </span>
                            </fieldset>
                        </dd>
                    </ul>
                    <ul class="w100">
                      <li class="tit_150">Keyword</li>
                      <li data-input-type="select" class="w100-150">
                        <div class="sel_input">
                          <select class="slt_white" id="subJectType" v-model="SUBJECT_TYPE">
                            <option value="S">Subject</option>
                            <option value="N">User Name</option>
                            <option value="I">User ID</option>
                          </select>
                          <span class="clearable">
                            <input
                              type="text"
                              class="text_input"
                              id="subJect" 
                              v-model="SUBJECT"
                              style="position: relative;"
                              placeholder=""
                              v-clearable
                            />
                            <i class="clearable_clear">{{ $t('BUTTON.GLOBAL.DELETE') }}</i>
                          </span>
                        </div>
                      </li>
                    </ul>
                    <ul class="w100">
                        <li class="tit_150">Action</li>
                        <li data-input-type="select" class="w100-150">
                            <!-- 200515수정 S -->
                            <fieldset class="ui_fieldset ui_right">
                                <label class="checkbox-wrap">
                                    <input type="checkbox"  v-model="selectAll" @change="toggleSelectAll"><i class="check-icon"></i>
                                    <em>All</em>
                                </label>
                                <label class="checkbox-wrap" v-for="item in checkList" :key="item">
                                    <input type="checkbox" :value="item" v-model="checkedNames"  @change="onUserLevelChange"><i class="check-icon"></i>
                                    <em>{{item}}</em>
                                </label>
                            </fieldset>
                            <!-- 200515수정 E -->
                        </li>
                    </ul>
                  </div>
                  <div class="srch_grupR_bottom">
                    <span class="btn">
                      <a href="javascript:" class="btn_srch" @click="search(1)">Search</a>
                    </span>
                  </div>
                </article>
              </div>
              <!-- Grid -->
              <!-- Grid -->
              <div class="grid_wrap number-cell">
                    <!-- Count -->
                <div class="grid_total">
                    Total&nbsp;Count&nbsp;
                    <em>{{ totalCount | numberFormat }}</em>
                </div>
                <div class="btn_wrap">
                    <a
                            href="javascript:"
                            class="btn_white"
                            @click="excelDownload()"
                            title
                        >{{ $t('FIELD.GLOBAL.EXCELDOWNLOAD') }}</a>
                </div>
                <!-- Grid -->
                <toast-grid
                    :gridId="gridId"
                    :data="gridData"
                    :columns="columns"
                    :options="options"
                    :key="gridKey"
                    :pageOptions="pageOptions"
                    :isTotalCount="false"
                    :click="contentClick"
                />
            </div>

            <div class="paginate">
                <sdl-pagination
                    :current-page="currentPage"
                    :total-rows="totalCount"
                    :per-page="perPage"
                    @change="search"
                    align="center"
                />
             </div>
            </div>
          </div>
          <!-- contents -->

</template>

<script>
import Vue                                  from 'vue';
import { mapActions, mapGetters }           from 'vuex';
import _                                    from 'lodash';
import $                                    from 'jquery';
import qs                                   from 'query-string';
import axios                                from 'axios';
import moment                               from 'moment';
import api                                  from '@/service';
import store                                from '@/vuex/store';
import constants                            from '@/constants';
import SDLLocale                            from '@/mixin/SDLLocale';
import { SDLUtil, StringUtil, MenuUtil }    from '@/utils';
import { EventBus }                         from '@/utils/EventBus';


import SKPBreadcrumbs                       from '~vb/main/SKPBreadcrumbs';
import DatePicker                           from '~c/DatePicker';
import ToastGrid                            from '~c/ToastGrid';

import ExcelDownloadPopup                   from '~vb/common/ExcelDownloadPopup';
import UnreadPopVue                         from '~va/statisticsManager/UnreadPop.vue';


// java to moment dateformat parser
require('moment-jdateformatparser');

const fetchGridData = params => axios.post(
    `${SDLUtil.API_URL}/basis/admin/statisticsManager/contentsStatisticsSearch.skp`,
    qs.stringify(params),
    { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
);

export default {
    name : 'UnreadList',
    props : {

    },
    data() {
        return {
            isProcess: true,

            selectRhqCd: '',
            selectRhqNm: '',
            selectRhqSubCd: '',
            selectRhqSubNm: '',

            rhqCdList: [],
            rhqSubCdList: [],

            BOARD_TYPE1: '',            // board Type - board parent id
            BOARD_TYPE2: '',            // board Type - board id
            boardType1List: [],         // board Type List 1
            boardType2List: [],         // board Type List 2

            PRD_CATEGORY_CD1: '',   // Category 1
            PRD_CATEGORY_CD2: '',   // Category 2
            PRD_CATEGORY_CD3: '',   // Category 3
            categoryComboList1: [], // Category 1 List
            categoryComboList2: [], // Category 2 List
            categoryComboList3: [], // Category 3 List

            FROM_DATE: {},     
            TO_DATE: {},    

            SUBJECT_TYPE: 'S',
            SUBJECT: '',

            selectAll: false,

            checkList: ['Add', 'Modify', 'View', 'Delete', 'Download', 'Approval(Add)','Approval(Modify)'],
            checkedNames:['Add'],

            pageTitle : '',
            perPage: parseInt(localStorage.getItem('listRows') || 10),
            currentPage: 1,
            totalCount : 0,
            gridId : "unreadGrid",
            gridKey: 0,
            gridData : [],
            columns : [
                {
                    header: "Content",
                    name: "BOARD_TYPE",
                    width: 200,
                    align: "left",
                    sortable: false,
                    resizable: true,
                },
                {
                    header: "Subject",
                    name: "KNOWLEDGE_TITLE",
                    align: "left",
                    sortable: false,
                    resizable: true,
                },
                {
                    header: "User Name",
                    name: "LOGIN_NAME",
                    align: "center",
                    width: 120,
                    sortable: false,
                    resizable: true,
                },
                {
                    header: "User ID",
                    name: "LOGIN_ID",
                    align: "center",
                    width: 120,
                    sortable: false,
                    resizable: true,
                },
                {
                    header: "Subsidiary",
                    name: "SUBSIDIARY_NM",
                    width: 120,
                    align: "center",
                    sortable: false,
                    resizable: true,
                },
                {
                    header: "SubsASC Account No",
                    name: "LOGIN_ACCOUNT_NO",
                    width: 150,
                    align: "center",
                    sortable: false,
                    resizable: true,
                },
                {
                    header: "Action",
                    name: "ACTION_NM",
                    width: 100,
                    align: "center",
                    sortable: false,
                    resizable: true,
                },
                {
                    header: "Time",
                    name: "ACTION_TIME",
                    align: "center",
                    width: 150,
                    sortable: false,
                    resizable: true,
                },
                {
                    header: "Category",
                    name: "PRD_CATEGORY",
                    align: "ricenterght",
                    width: 120,
                    sortable: false,
                    resizable: true,
                },
                {
                    header: "Model",
                    name: "MODEL_NM",
                    align: "center",
                    width: 120,
                    sortable: false,
                    resizable: true,
                },
            ],
            options : {
                scrollX: true,
                scrollY: false,
                header: { height: 45 },
                rowHeight: 45,
            },
            pageOptions : {},
        }
    },
    computed: {
        ...mapGetters({
            userRoles:  'getRoles',
            userCorpCd: 'getCorpCd',
            params:     'getParams',
            locale:     'getLocale',
            menus:      'getMenus',
            loginNo:    'getLoginNo',
            loginRhq:   'getLoginRhq'
        }),
        getDateformat() {
            return localStorage.getItem('mDateFormat');
        },
        getLoginUser() {
            return SDLUtil.getLoginedUserInfo();
        },
        getLoginRHQCd() {
            return this.loginRhq || '';
        },
        getLoginCompanyCd() {
            return this.userCorpCd || '';
        },
        getLoginNo() {
            return this.loginNo || '';
        },
        getUserRole() {
            return this.userRoles || '';
        },
        getSelBoardType1()      { return this.BOARD_TYPE1 || ''; },
        getSelBoardType2()      { return this.BOARD_TYPE2 || ''; },


    },
    components: {
        'skp-breadcrumbs' : SKPBreadcrumbs,
        'toast-grid' : ToastGrid
    },
    methods: {
        categoryClear(){
            this.setCategory1();
            this.categoryComboList2 = [], this.PRD_CATEGORY_CD2 = '';
            this.categoryComboList3 = [], this.PRD_CATEGORY_CD3 = '';
        },
        async getCodeComboList(categoryVal, categoryCode) {
            let corpCd = this.selectRhqSubCd == "" ? this.getUserCorpCd : this.selectRhqSubCd;
            const codeResp = await api.getComboList(categoryVal, categoryCode, corpCd);
            return codeResp;
        },
        async getCodeComboList1(categoryVal, categoryCode) {
            const codeResp = await api.getComboList(categoryVal, categoryCode, this.getLoginNo);
            return codeResp;
        },
        getComboBoxVal(comboId) {
            return document.getElementById(comboId) ? document.getElementById(comboId).value : "";
        },
        getComboBoxName(comboId) {
            return document.getElementById(comboId) ? document.getElementById(comboId).name : "";
        },
        // 지역 코드 변경 이벤트
        changeRhqCd(e) {
            let comboValue = this.getComboBoxVal(e.target.id);
            if(comboValue == "") {
                this.rhqSubCdList = [], this.selectRhqSubCd = '';
            } else {
                this.getCodeComboList1(comboValue, "SUB_AUTH_ACCESS_CD").then(data => {
                    this.rhqSubCdList = data;
                    this.selectRhqSubCd = '';
                });
            }
            this.categoryClear();
            this.boardType1List = [], this.BOARD_TYPE1 = '';
            this.boardType2List = [], this.BOARD_TYPE2 = '';
        },
        // 법인 코드 변경 이벤트
        changeRhqSubCd(e) {
            let comboValue = this.getComboBoxVal(e.target.id);
            if(comboValue == "") {
                this.selectRhqSubCd = '';
                this.selectRhqSubNm = '';
                this.boardType1List = [], this.BOARD_TYPE1 = '';
                this.boardType2List = [], this.BOARD_TYPE2 = '';

            } else {
                this.selectRhqSubCd = this.getComboBoxVal(e.target.id);
                this.selectRhqSubNm = this.getComboBoxName(e.target.id);
                this.boardType1List = [], this.BOARD_TYPE1 = '';
                this.boardType2List = [], this.BOARD_TYPE2 = '';
                this.setBoardType1();
            }
            this.categoryClear();
            
        },

        // Board1 setting
        setBoardType1() {
            this.getCodeComboList(this.selectRhqSubCd, "BOARD_TYPE1").then(data => {
                this.BOARD_TYPE1 = this.getSelBoardType1;
                this.boardType1List = data;
            });

            let that = this;
            return new Promise(function(resolve) {
                setTimeout( function(){ resolve(); }, 100 );
            });
        },
        // Board2 setting
        setBoardType2() {
            this.getCodeComboList(this.getSelBoardType1, "BOARD_TYPE2").then(data => {
                this.BOARD_TYPE2 = this.getSelBoardType2;
                this.boardType2List = data;
            });
        },
        // Board1 combo change event => create Board2 combo list
        changeBoardType1(e) {
            let comboValue = StringUtil.getComboboxValue(e.target.id);
            if(comboValue == "") {
                this.boardType2List = [], this.BOARD_TYPE2 = '';
            } else {
                this.getCodeComboList(comboValue, "BOARD_TYPE2").then(data => {
                    this.boardType2List = data;
                    this.BOARD_TYPE2 = '';
                });
            }
        },
       
        // 첫번째 카테고리 설정
        setCategory1() {
            this.getCodeComboList("0", "ADM_CATEGORY_A").then(data => {
                this.PRD_CATEGORY_CD1 = "";
                this.categoryComboList1 = data;
            });

            let that = this;
            return new Promise(function(resolve) {
                setTimeout( function(){ resolve(); }, 100 );
            });
        },
        // 첫번째 카테고리 변경 이벤트
        changeCategory1() {
            if(this.PRD_CATEGORY_CD1 == "") {
                this.categoryComboList2 = [], this.PRD_CATEGORY_CD2 = '';
                this.categoryComboList3 = [], this.PRD_CATEGORY_CD3 = '';

            } else {
                this.getCodeComboList(this.PRD_CATEGORY_CD1, "ADM_CATEGORY_B").then(data => {
                    this.PRD_CATEGORY_CD2 = '';
                    this.categoryComboList2 = data;
                });

                this.categoryComboList3 = [], this.PRD_CATEGORY_CD3 = '';
            }
        },
        // 두번째 카테고리 변경 이벤트
        changeCategory2() {
            if(this.PRD_CATEGORY_CD2 == "") {
                this.categoryComboList3 = [], this.PRD_CATEGORY_CD3 = '';

            } else {
                this.getCodeComboList(this.PRD_CATEGORY_CD2, "ADM_CATEGORY_C").then(data => {
                    this.PRD_CATEGORY_CD3 = '';
                    this.categoryComboList3 = data;
                });
            }
        },
        // 세번째 카테고리 변경 이벤트
        async changeCategory3() {
            if(this.PRD_CATEGORY_CD3 == "") {
                this.categoryComboList3 = [], this.PRD_CATEGORY_CD3 = '';
            }
        },

        

        // 권한체크
        isAllUser(){
            
            if(this.getUserRole.includes(`${constants.SYSTEM_ADMIN}`) || 
               this.getUserRole.includes(`${constants.GBM_ADMIN}`) ||
               this.getUserRole.includes(`${constants.RHQ_ADMIN}`)) 
            {
                return true;
            }else{
                return false;
            }
            
        },

        // 버튼 이벤트
        async search(pageNo) {
            
            let validContents = this.registVerifyContents();
            let checkedVal = "";
            if(this.checkedNames.length > 0) {
                checkedVal = this.checkedNames.join(',');
            }    
            if(validContents) {
                if (!pageNo) pageNo = 1;
                const mFormat = localStorage.getItem('mDateFormat');
                let params = {
                    page             : pageNo,
                    RHQCD            : this.selectRhqCd,
                    RHQSUBCD         : this.selectRhqSubCd,
                    BOARD_TYPE1      : this.getSelBoardType1,
                    BOARD_TYPE2      : this.getSelBoardType2,
                    PRD_CATEGORY_CD1 : this.PRD_CATEGORY_CD1,
                    PRD_CATEGORY_CD2 : this.PRD_CATEGORY_CD2,
                    PRD_CATEGORY_CD3 : this.PRD_CATEGORY_CD3,
                    FROM_DATE        : this.rangePicker.getStartDate() ? moment(this.rangePicker.getStartDate()).format(mFormat) : '',
                    TO_DATE          : this.rangePicker.getEndDate() ? moment(this.rangePicker.getEndDate()).format(mFormat) : '',
                    SUBJECT_TYPE     : this.SUBJECT_TYPE,
                    SUBJECT          : this.SUBJECT,
                    CHECKEDVAL       : checkedVal,
                };

                SDLUtil.showLoadingBar(true);
                const response = await fetchGridData(params)
                    .then(res => {
                        let data = res.data;
                        this.totalCount = data.totalCount;
                        this.gridData = data.result;
                        this.gridKey++;
                        this.currentPage = pageNo;
                        SDLUtil.showLoadingBar(false);
                    })
                    .catch(err => {
                        SDLUtil.errorAlert(err);
                        SDLUtil.showLoadingBar(false);
                    });
            }
        },
        // 컨텐츠 클릭 이벤트 -> KnowledgeListGrid
        contentClick(e, rowData, grid) {

            let colNm = e.columnName;
            if ((typeof e.rowKey) === "undefined") return;
            let row = rowData[e.rowKey];
            let knowledgeId = row['KNOWLEDGE_ID'] || '';
            let corpNo      = row['CORP_NO'] || '';
            let searchDate  = row['SEARCH_DATE'] || '';
            // 컬럼별 이벤트 실행
            if( colNm === 'NOT_YET_CNT') {
                if(knowledgeId !== null) {
                    SDLUtil.show(
                        UnreadPopVue,
                        { knowledgeId: knowledgeId , corpNo: corpNo, searchDate: searchDate },
                        { height: 'auto' }
                    );
                }
            } 
            
        },
        excelDownload() {
            SDLUtil.confirm({
                msg: 'Do you want to download the Excel file?<br>Data will be download up to 5000 lines.',
                onOkEvt: () => {
                    let checkedVal = "";
                    if(this.checkedNames.length > 0) {
                        checkedVal = this.checkedNames.join(',');
                    }      

                    const mFormat = localStorage.getItem('mDateFormat');
                    SDLUtil.showLoadingBar(true);
                    return axios
                        .post(
                            `${SDLUtil.API_URL}/basis/admin/statisticsManager/contentsStatisticsExcel.skp`,
                            qs.stringify({
                                RHQCD            : this.selectRhqCd,
                                RHQSUBCD         : this.selectRhqSubCd,
                                BOARD_TYPE1      : this.getSelBoardType1,
                                BOARD_TYPE2      : this.getSelBoardType2,
                                PRD_CATEGORY_CD1 : this.PRD_CATEGORY_CD1,
                                PRD_CATEGORY_CD2 : this.PRD_CATEGORY_CD2,
                                PRD_CATEGORY_CD3 : this.PRD_CATEGORY_CD3,
                                FROM_DATE        : this.rangePicker.getStartDate() ? moment(this.rangePicker.getStartDate()).format(mFormat) : '',
                                TO_DATE          : this.rangePicker.getEndDate() ? moment(this.rangePicker.getEndDate()).format(mFormat) : '',
                                SUBJECT_TYPE     : this.SUBJECT_TYPE,
                                SUBJECT          : this.SUBJECT,
                                CHECKEDVAL       : checkedVal,
                            }),
                        )
                        .then(resp => {
                            SDLUtil.showLoadingBar(false);
                            if (resp.data.EXCEL_FILES.length > 0) {
                                SDLUtil.show(
                                    ExcelDownloadPopup,
                                    {
                                        title: SDLUtil.getMsgProp('TITLE.EXCEL.DOWNLOAD'),
                                        excelFiles: resp.data.excelFiles,
                                    },
                                    {
                                        height: 'auto',
                                    },
                                );
                            }
                            SDLUtil.showLoadingBar(false);
                        })
                        .catch(err => {
                            Vue.$log.error(err);
                            SDLUtil.errorAlert(err);
                            SDLUtil.showLoadingBar(false);
                        });
                },
            });
        },
        registVerifyContents() {
            let validList = [''];
            if(SDLUtil.isNull(this.rangePicker.getStartDate()))    validList.push((validList.length > 0 ? '<br/>' : '') + '<span class="txt_color1">' + 'Period' + '</span>');
            if(SDLUtil.isNull(this.rangePicker.getEndDate()))    validList.push((validList.length > 0 ? '<br/>' : '') + '<span class="txt_color1">' + 'Period' + '</span>');
            if(validList.length > 1) {
                SDLUtil.alert({
                    msg: 'The following fields are required to start search.' + '<br/>' + '<span class="txt_color1">' + 'Period' + '</span>',
                    class: 'sm_size'
                });
                return false;
            } else {
                return true;
            }
        },
        toggleSelectAll(e) {
            if (this.selectAll) {
                this.checkedNames = [];
                this.checkedNames = this.checkList;
            } else {
                this.checkedNames = [];
            }
        },
        onUserLevelChange(e) {
            this.selectAll =
            this.checkedNames.length == this.checkList.length ? true : false;
        },
    },
    created() {
        // 초기 카테고리1 리스트 로드
        this.setCategory1();
    },

    mounted() {
        
        this.$nextTick(() => {
            this.getCodeComboList1(this.getLoginNo, "RHQ_AUTH_ACCESS_CD")
                .then(data => {
                    this.rhqCdList = data;
                    this.selectRhqCd =  this.getLoginRHQCd;
                });

            this.getCodeComboList1(this.getLoginRHQCd, "SUB_AUTH_ACCESS_CD")
                .then(data => {
                    this.rhqSubCdList = data;
                    this.selectRhqSubCd = this.getLoginCompanyCd;
                });
            this.getCodeComboList(this.getLoginCompanyCd, "BOARD_TYPE1").then(data => {
                this.boardType1List = data;
                this.BOARD_TYPE1 = "";
            });
//            let toDate = new Date();    
//            let fromDate = toDate.setMonth(toDate.getMonth() - 1);
            //this.FROM_DATE = DatePicker.create('from-picker-container', 'fromDate', 'icoFromDate', 'en', {} ,fromDate);
            //this.TO_DATE   = DatePicker.create('to-picker-container', 'toDate', 'icoToDate', 'en', {} ,new Date());    
            this.rangePicker = DatePicker.createRangeWithOpener(
                            'from-picker-container', 'fromDate', 'icoFromDate',
                            'to-picker-container', 'toDate', 'icoToDate',
                            { type: 'date', locale: 'en', showToday: false },
                            (new moment()).add(-1, 'month').toDate(),
                            (new moment()).toDate()
            );  
        });
    },
    beforeDestroy() {

    }
};
</script>

<style>
    /*  사용시 해당 컨포넌트에서만 사용 */
.zindex9999 { z-index: 99999999; }
.top20 {top: -20px;}
.float-none {float: none;}
.ftColor { color: dodgerblue!important; font-weight: bold!important; }
.tui-datepicker {
    z-index: 9999;
    border: 1px solid #aaa;
    background-color: white;
    position: absolute;
}
</style>


// WEBPACK FOOTER //
// src/skpComponents/view/admin/statisticsManager/contentsStatisticsList.vue